import { Injectable } from '@angular/core';
import { IAdapter } from 'src/app/models';
import { TaskListOperation } from 'src/app/models/domain';
import { YPMTASKLISTSRVOperations } from 'src/generated-clients/tasklist';
import { TaskListCharacteristicAdapter } from './task-list-characteristic-adapter';

@Injectable({
  providedIn: 'root',
})
export class TaskListOperationAdapter implements IAdapter<
  TaskListOperation,
  YPMTASKLISTSRVOperations
> {
  public constructor(public taskListCharacteristicAdapter: TaskListCharacteristicAdapter) {}

  public adaptToDomain(operationDto: YPMTASKLISTSRVOperations): TaskListOperation {
    return new TaskListOperation(
      operationDto.groupCounter ?? '',
      operationDto.sequence ?? '',
      operationDto.taskListType ?? '',
      operationDto.taskListGroup ?? '',
      operationDto.nodes ?? '',
      operationDto.operationShortText ?? ''
    );
  }
}
